import { css, html } from "../helpers/webComponents";
import { DragonHeadService } from "../services/DragonHeadService";
import { CanvasComponent } from "./CanvasComponent";

const styles: string = css`
:host {
    z-index: 8;
    display: flex;
    justify-content: center;
}
    .dragon-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;

}

.dragon-head {
    width: 300px;
    height: 300px;
    background-image: url("../assets/img/rooms/layers/dragonClosedfinal.png");
    background-size: cover;
    background-position: center;
    cursor: pointer;
}

.dragon-head.slightlyOpen {
    background-image: url("../assets/img/rooms/layers/dragonslightlyfinal.png");
}

.dragon-head.almostOpen {
    background-image: url("../assets/img/rooms/layers/dragonalmostfinal.png");
}

.dragon-head.open {
    background-image: url("../assets/img/rooms/layers/dragonopenfinal.png"); 
}

.message {
    font-size: 18px;
    color: green;
    margin-top: 15px;
    text-align: center;
    display: block;
}

`;

export class DragonHeadComponent extends HTMLElement {
    private clickCount: number = 0;
    private dragonElement: HTMLElement;
    private messageElement: HTMLElement;

    public constructor() {
        super();
        this.dragonElement = document.createElement("div");
        this.messageElement = document.createElement("div");
    }

    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        this.render();
        this.afterRenderStuff();
    }

    public render(): void {
        if (this.shadowRoot) {
            this.shadowRoot.innerHTML = `
            <style>
                ${styles}
            </style>
            <div class="dragon-container">
                <div class="dragon-head"></div>
                <div class="message">hmm, maybe by touching the head I can open the mouth</div>
                <button class="cross" style="display: none;">X</button>
            </div>`;
        }
    }

    public afterRenderStuff(): void {
        this.dragonElement = this.shadowRoot?.querySelector(".dragon-head") as HTMLElement;
        this.messageElement = this.shadowRoot?.querySelector(".message") as HTMLElement;

        this.dragonElement.addEventListener("click", () => this.handleClick());
    }

    public renderCloseButton(): HTMLElement {
        const cross: HTMLElement = html`
                <div class="cross">
                    X
                </div>
            `;
        cross.addEventListener("click", () => {
            CanvasComponent.closeFromSubcomponent();
        });
        return cross;
    }

    private async handleClick(): Promise<void> {
        if (this.clickCount >= 20) return;
        this.clickCount++;

        if (this.clickCount === 0) {
            this.messageElement.style.setProperty("display", "block");
        }

        if (this.clickCount === 5) {
            this.dragonElement.classList.add("slightlyOpen");
            this.messageElement.textContent = "The mouth is slightly open...";
        }

        if (this.clickCount === 15) {
            this.dragonElement.classList.add("almostOpen");
            this.messageElement.textContent = "Almost there!";
        }

        if (this.clickCount === 20) {
            this.dragonElement.classList.add("open");
            this.messageElement.textContent = "Opening mouth...";

            const dragonHeadService: DragonHeadService = new DragonHeadService();
            try {
                await dragonHeadService.openMouth("character-sheet-1", "character-sheet-2", "character-sheet-3");
                this.messageElement.textContent = "You opened the dragon's mouth and received the character sheets!";
                setTimeout(() => {
                    CanvasComponent.closeFromSubcomponent();
                },
                2000);
            }
            catch {
                this.messageElement.textContent = "Something went wrong opening the dragon's mouth.";
            }
        }
    }
}
